/**
 * API服务
 */
import axios from 'axios';

const api = axios.create({
  baseURL: '/',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

// 请求拦截器
api.interceptors.request.use(
  config => {
    // 添加token到请求头
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 响应拦截器
api.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response) {
      // 如果是401错误，可能是token过期，清除用户信息并跳转到登录页
      if (error.response.status === 401) {
        // 清除用户信息
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        
        // 这里可以添加跳转到登录页的逻辑
        console.error('认证失败，请重新登录');
      }
    }
    return Promise.reject(error);
  }
);

export default api; 